import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

// Reusable across form conversion types (player bios, and later news/feature stories).
export default class extends Controller {
  static targets = ["presetSelect", "questionCheckbox", "presetName"]
  static values = {
    saveUrl: String,
  }

  applyPreset() {
    if (!this.hasPresetSelectTarget) return

    const selectedOption = this.presetSelectTarget.selectedOptions[0]
    if (!selectedOption) return

    const rawIds = selectedOption.dataset.questionIds
    if (rawIds == null || rawIds === "") return

    let questionIds = []
    try {
      questionIds = JSON.parse(rawIds).map((id) => String(id))
    } catch (error) {
      console.error("Unable to parse conversion question IDs", error)
      return
    }

    this.questionCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = questionIds.includes(String(checkbox.value))
    })
  }

  // Block opening the save modal when nothing is checked.
  prepareSave(event) {
    const checkedIds = this.selectedQuestionIds()
    if (checkedIds.length === 0) {
      event.preventDefault()
      event.stopImmediatePropagation()
      createAlert("warning", "Select at least one question to save.")
    }
  }

  savePreset(event) {
    event.preventDefault()

    const name = this.hasPresetNameTarget ? this.presetNameTarget.value.trim() : ""
    const questionIds = this.selectedQuestionIds()

    if (name.length === 0) {
      createAlert("warning", "Please enter a name for this question selection.")
      return
    }

    if (questionIds.length === 0) {
      createAlert("warning", "Select at least one question to save.")
      return
    }

    if (!this.saveUrlValue) {
      createAlert("danger", "Unable to save question selection.")
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    fetch(this.saveUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        name: name,
        question_ids: questionIds,
      }),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}))
        if (!response.ok) {
          throw new Error(data.error || "Unable to save question selection.")
        }
        return data
      })
      .then((data) => {
        this.addPresetOption(data)
        this.closeSaveModal()
        if (this.hasPresetNameTarget) this.presetNameTarget.value = ""
        createAlert("success", "Question selection saved.")
      })
      .catch((error) => {
        createAlert("danger", error.message || "Unable to save question selection.")
      })
  }

  selectedQuestionIds() {
    return this.questionCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)
  }

  addPresetOption(data) {
    if (!this.hasPresetSelectTarget || !data?.id) return

    const option = document.createElement("option")
    option.value = String(data.id)
    option.textContent = data.name
    option.dataset.questionIds = JSON.stringify(data.question_ids || [])
    option.selected = true
    this.presetSelectTarget.appendChild(option)
  }

  selectAllQuestions(event) {
    this.questionCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = event.currentTarget.checked;
    })
  }

  closeSaveModal() {
    const modalElement = document.getElementById("forms-conversion-save-questions-modal")
    if (!modalElement || !window.bootstrap?.Modal) return

    window.bootstrap.Modal.getOrCreateInstance(modalElement).hide()
  }
}
